/*
 * SPW トップページ 横スクロール自動送り（2026-10-19）
 * 対象：NEW RELEASE / RANKING（section-carousel）、BLOG（section-blog）、CATEGORIES（collection-row）
 * - PC：テーマのFlickityインスタンス（flickity-carousel.carouselInstance）で1枚ずつ送る。最後まで行ったら先頭へ
 * - スマホ：ネイティブ横スクロールを1枚分ずつ送る。最後まで行ったら先頭へ
 * - ホバー／タッチ／ドラッグ中は止め、離してから RESUME_MS 後に再開
 * - 画面外・タブ非表示のときは動かさない。「視差効果を減らす」設定の端末では動かさない
 */
(function () {
  var INTERVAL_MS = 4000;
  var RESUME_MS = 6000;
  var TARGETS = ['section-carousel', 'section-blog', 'collection-row'];

  if (window.__spwAutoScroll) return;
  window.__spwAutoScroll = true;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function setup(wrapper) {
    if (wrapper.__spwAuto) return;
    wrapper.__spwAuto = true;

    var visible = false;
    var pausedUntil = 0;
    var holding = false;

    function pause() { holding = true; }
    function release() { holding = false; pausedUntil = Date.now() + RESUME_MS; }

    ['pointerenter', 'pointerdown', 'touchstart', 'focusin'].forEach(function (ev) {
      wrapper.addEventListener(ev, pause, { passive: true });
    });
    ['pointerleave', 'pointerup', 'touchend', 'touchcancel', 'focusout'].forEach(function (ev) {
      wrapper.addEventListener(ev, release, { passive: true });
    });
    wrapper.addEventListener('wheel', release, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
      }, { threshold: 0.3 }).observe(wrapper);
    } else {
      visible = true;
    }

    function stepFlickity(inst) {
      var next = wrapper.carouselNext;
      var atEnd = (next && next.disabled) || inst.selectedIndex >= inst.slides.length - 1;
      if (atEnd) {
        if (inst.selectedIndex !== 0) inst.select(0);
      } else {
        inst.next();
      }
    }

    function stepNative() {
      var sc = wrapper.querySelector('[data-custom-scrollbar-items]');
      if (!sc) return;
      var max = sc.scrollWidth - sc.clientWidth;
      if (max <= 4) return;
      var item = sc.querySelector('[data-item]');
      var step = item ? item.getBoundingClientRect().width : sc.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(sc).columnGap) || 0;
      if (sc.scrollLeft >= max - 4) {
        sc.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        sc.scrollBy({ left: step + gap, behavior: 'smooth' });
      }
    }

    setInterval(function () {
      if (!visible || holding || document.hidden || Date.now() < pausedUntil) return;
      var inst = wrapper.carouselInstance;
      if (inst && inst.isActive) {
        stepFlickity(inst);
      } else {
        stepNative();
      }
    }, INTERVAL_MS);
  }

  function init() {
    TARGETS.forEach(function (type) {
      document.querySelectorAll('[data-section-type="' + type + '"] flickity-carousel').forEach(setup);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // テーマエディタでセクションを再描画したとき用
  document.addEventListener('shopify:section:load', init);
})();
